import { useMemo } from 'react';
import * as yup from 'yup';
import FieldRepeaterCText from 'src/components/ui/FieldRepeater/connectors/FieldRepeaterCText';
import FieldRepeaterCSites from 'src/components/ui/FieldRepeater/connectors/FieldRepeaterCSites';
import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';
import dayjs from 'dayjs';

const parseKnownFrom = (value) => {
	if (!value) return null;

	const parsed = dayjs(value);

	return parsed.isValid() ? parsed : null;
};

const isValidSite = (value) => {
	if (!value) return true;

	const trimmed = String(value).trim();
	const withProtocol = /^https?:\/\//i.test(trimmed)
		? trimmed
		: `https://${trimmed}`;

	try {
		const url = new URL(withProtocol);
		return Boolean(url.hostname) && url.hostname.includes('.');
	} catch {
		return false;
	}
};

export const useFormAreaParams = (params = {}) => {
	const { values, initialData } = params;

	const initialValues = useMemo(() => {
		const emails = (values?.emails ?? initialData?.emails ?? []).filter(
			Boolean,
		);
		const sites = (values?.sites ?? initialData?.sites ?? []).filter(
			Boolean,
		);

		return {
			date:
				values?.date !== undefined
					? parseKnownFrom(values.date) ?? values.date
					: parseKnownFrom(initialData?.knownFrom),
			emails: emails.length ? emails : [''],
			sites: sites.length ? sites : [''],
		};
	}, [values, initialData]);

	const shape = useMemo(() => {
		return {
			groups: [
				{
					id: 1,
					lines: [
						{
							id: 1,
							field: {
								type: FORM_LINE_TYPES.datepicker,
								connected: true,
								params: {
									placeholder: 'Выберите',
									label: 'Известен с',
									name: 'date',
								},
							},
						},
						{
							id: 2,
							repeater: {
								Component: FieldRepeaterCText,
								name: 'emails',
								label: 'Эл. почта',
								fieldParams: {
									type: 'email',
									placeholder: 'name@mail.ru',
								},
							},
						},
						{
							id: 3,
							repeater: {
								Component: FieldRepeaterCSites,
								name: 'sites',
								label: 'Ссылки',
							},
						},
					],
				},
			],
		};
	}, []);

	const validationSchema = yup.object().shape({
		date: yup
			.mixed()
			.required('Укажите дату')
			.test('valid-date', 'Укажите дату', (value) =>
				dayjs(value).isValid(),
			),
		emails: yup.array().of(
			yup
				.string()
				.trim()
				.test(
					'email',
					'Укажите корректный email',
					(value) => !value || yup.string().email().isValidSync(value),
				),
		),
		sites: yup.array().of(
			yup
				.string()
				.trim()
				.test('url', 'Укажите корректную ссылку', isValidSite),
		),
	});

	return { shape, initialValues, validationSchema };
};
